"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.compose = function () {
    var funcs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        funcs[_i] = arguments[_i];
    }
    if (funcs.length === 0) {
        return function (arg) { return arg; };
    }
    if (funcs.length === 1) {
        return funcs[0];
    }
    return funcs.reduce(function (a, b) { return function (arg1) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return a.apply(void 0, [b.apply(void 0, [arg1].concat(args))].concat(args));
    }; });
};
exports.applyFeatures = function () {
    var features = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        features[_i] = arguments[_i];
    }
    return function (createStore) { return function (reducer, preloadedState) {
        var featureReducer = exports.compose.apply(void 0, features.concat([reducer]));
        var featureState = __assign({}, featureReducer(undefined, undefined), preloadedState);
        return createStore(featureReducer, featureState);
    }; };
};
exports.isPrimitive = function (value) {
    return typeof value === 'string' ||
        typeof value === 'number' ||
        typeof value === 'boolean';
};
exports.isPrimitiveArray = function (value) {
    return Array.isArray(value) &&
        value.reduce(function (prev, curr) { return prev && exports.isPrimitive(curr); }, true);
};
exports.isPrimitiveMap = function (value) {
    return typeof value === 'object' &&
        Object.keys(value).reduce(function (prev, curr) { return prev && typeof curr === 'string'; }, true) &&
        Object.values(value).reduce(function (prev, curr) { return prev && exports.isPrimitive(curr); }, true);
};
exports.isPrimitiveRecord = function (value) {
    return typeof value === 'object' &&
        value.key !== undefined &&
        typeof value.key === 'string' &&
        value.value !== undefined &&
        exports.isPrimitive(value.value) &&
        Object.keys(value).length === 2;
};
exports.isPrimitiveRecordArray = function (value) {
    return Array.isArray(value) &&
        value.reduce(function (prev, curr) { return prev && exports.isPrimitiveRecord(curr); }, true);
};
//# sourceMappingURL=applyFeatures.js.map